"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formattedDescription = void 0;
function formattedDescription(source) {
    if (!source || source.length === 0) {
        return '';
    }
    let description;
    try {
        description = JSON.parse(source);
    }
    catch (e) {
        return source.replace(/(\r\n|\n|\r)/g, '<br/>');
    }
    let str = '';
    // show tags if there are more than one
    let showTags = description.length > 1;
    description.forEach(function (paragraph) {
        if (showTags && paragraph.name && paragraph.name.length > 0) {
            let name = paragraph.name.replace(/(\r\n|\n|\r)/g, '<br/>');
            str += '<h3>' + name + '</h3>';
        }
        if (paragraph.text && paragraph.text.length > 0) {
            let text = paragraph.text.replace(/(\r\n|\n|\r)/g, '<br/>');
            str += '<span>' + text + '</span>';
        }
    });
    return str;
}
exports.formattedDescription = formattedDescription;
